"use client";

import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@src/lib/utils";
function Popover({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} data-sentry-element="PopoverPrimitive.Root" data-sentry-component="Popover" data-sentry-source-file="popover.tsx" />;
}
function PopoverTrigger({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Trigger>) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} data-sentry-element="PopoverPrimitive.Trigger" data-sentry-component="PopoverTrigger" data-sentry-source-file="popover.tsx" />;
}
function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return <PopoverPrimitive.Portal data-sentry-element="PopoverPrimitive.Portal" data-sentry-component="PopoverContent" data-sentry-source-file="popover.tsx">
      <PopoverPrimitive.Content data-slot="popover-content" align={align} sideOffset={sideOffset} className={cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden", className)} {...props} data-sentry-element="PopoverPrimitive.Content" data-sentry-source-file="popover.tsx" />
    </PopoverPrimitive.Portal>;
}
function PopoverAnchor({
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Anchor>) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} data-sentry-element="PopoverPrimitive.Anchor" data-sentry-component="PopoverAnchor" data-sentry-source-file="popover.tsx" />;
}
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };